<template>
    <DataList categoryKey="工厂"></DataList>
</template>

<script>
import DataList from '../company/data-list.vue'
export default {
    components:{DataList}
}
</script>